import { Card } from '@cmsgov/ds-medicare-gov'

import classes from './CardStack.module.scss'
import classNames from 'classnames'

type CardStackProps = {
  className?: string
  children: React.ReactNode
}
export function CardStack ({ children, className }: CardStackProps) {
  return (
    <Card className={className}>
      {children}
    </Card>
  )
}

type CardStackItemProps = {
  className?: string
  children: React.ReactNode
}
export function CardStackItem ({ className, children }: CardStackItemProps) {
  return <div className={classNames(classes.item, classes.child, className)}>{children}</div>
}
